function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './spzaComponent';
import { InternalLink } from './internalLink';
import { Constants } from './../utils/constants';
export class ButtonLink extends SpzaComponent {
    renderImpl() {
        let button = null;
        switch(this.props.type){
            case Constants.ButtonType.Link:
                button = /*#__PURE__*/ _jsxs(InternalLink, {
                    accEnabled: this.props.accEnabled,
                    href: this.props.href,
                    role: "link",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "ms-fontSize-14",
                            children: this.props.label + ' '
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "ms-fontSize-16 ms-fontWeight-semibold",
                            children: this.props.value
                        })
                    ]
                });
                break;
            case Constants.ButtonType.Label:
                button = /*#__PURE__*/ _jsxs("div", {
                    className: "buttonLinkContainer",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "ms-fontSize-14 label",
                            children: this.props.label + ' '
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "ms-fontSize-16 ms-fontWeight-semibold",
                            children: this.props.value
                        })
                    ]
                });
                break;
            default:
                button = /*#__PURE__*/ _jsx("div", {});
        }
        return /*#__PURE__*/ _jsx("div", {
            className: 'button-link ' + this.props.className,
            children: button
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
ButtonLink.contextTypes = {};
